import { FormInput, SwitchInput } from "@4uhub/lib4uhub";
import { Divider, Grid, Typography } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { RobotRules } from "./RobotRules/RobotRules";
import { BusAutomationSelect } from "./BusAutomationSelect/BusAutomationSelect";
import { ExamMachineModalitySelect } from "./ExamMachineModalitySelect/ExamMachineModalitySelect";
import { ExamMachineSelect } from "./ExamMachineSelect/ExamMachineSelect";

const translationPath = "page.4uBus.uBusAutomationRobot.";

export const BasicData = memo(() => {
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} sm={7}>
        <BusAutomationSelect />
      </Grid>

      <Grid item xs={12} sm={5} textAlign={"end"}>
        <SwitchInput
          name="enable"
          label={t(translationPath + "enable") || "Enable"}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
          Origem dos Arquivos
        </Typography>
        <Divider sx={{ mb: 3 }} />
      </Grid>

      <Grid item xs={12} sm={6}>
        <FormInput
          name="name"
          label={t(translationPath + "name")}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          name="pathSeparator"
          label={t(translationPath + "path_separator")}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          name="suffixPrefix"
          label={t(translationPath + "suffixPrefix")}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <FormInput
          type="number"
          name="identificationPosition"
          label={t(translationPath + "identificationPosition")}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ExamMachineModalitySelect />
      </Grid>
      <Grid item xs={12} sm={6}>
        <ExamMachineSelect />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormInput
          name="path"
          label={t(translationPath + "path")}
          size="small"
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={12}>
        <FormInput
          name="description"
          label={t(translationPath + "description")}
          multiline
          fullWidth
          minRows={3}
        />
      </Grid>

      <Grid item xs={12} sm={12}>
        <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
          Destino dos Arquivos
        </Typography>
        <Divider sx={{ mb: 3 }} />
      </Grid>

      <RobotRules />
    </>
  );
});
